import React, {useCallback, useEffect, useRef, useState} from "react";
import {isAdmin} from "../../../components/commonmethod/CommonMethod";
import {handleActiveError, handleActiveToast} from "../../../components/sonner/ToastBasic";
import ApprovalComponent from "../approval/new/ApprovalComponent";
import {
    getCurrentApprovalProcess,
    updateComputerRoomApprovalProcess,
} from "../../../api/computerRoom/ComputerRoomService";
import {useSelector} from "react-redux";
import "../groupCode/groupCodeManage.css";
import "./computerRoomApproval.css";

function ComputerRoomApprovalSettings() {
    const user = useSelector((state) => state.auth.user);
    const isAdminUser = isAdmin(user);

    const [approvalProcessId, setApprovalProcessId] = useState(null);
    const [cleared, setCleared] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const persistRef = useRef(false);

    useEffect(() => {
        if (!isAdminUser) {
            setLoaded(true);
            return;
        }

        let cancelled = false;

        getCurrentApprovalProcess()
            .then((response) => {
                if (cancelled) return;
                const id = response?.status === 200 ? response.data?.approvalProcess?.id : null;
                setApprovalProcessId(id ?? null);
                setCleared(false);
            })
            .catch(() => {
                if (!cancelled) {
                    setApprovalProcessId(null);
                }
            })
            .finally(() => {
                if (cancelled) return;
                setLoaded(true);
                requestAnimationFrame(() => {
                    persistRef.current = true;
                });
            });

        return () => {
            cancelled = true;
        };
    }, [isAdminUser]);

    const effectiveProcessId = cleared ? undefined : approvalProcessId;

    const handleApprovalProcessSet = useCallback(async (process) => {
        if (!persistRef.current) {
            return;
        }

        const nextId = process?.id ?? null;

        if (nextId === approvalProcessId && !cleared) {
            return;
        }

        try {
            await updateComputerRoomApprovalProcess(nextId);
            setApprovalProcessId(nextId);
            setCleared(false);
            if (nextId) {
                handleActiveToast({message: "결재라인이 저장되었습니다."});
            }
        } catch {
            handleActiveError({message: "결재라인 저장에 실패했습니다."});
        }
    }, [approvalProcessId, cleared]);

    const handleClear = async () => {
        try {
            await updateComputerRoomApprovalProcess(null);
            setApprovalProcessId(null);
            setCleared(true);
            handleActiveToast({message: "결재라인이 초기화되었습니다."});
        } catch {
            handleActiveError({message: "초기화 중 오류가 발생했습니다."});
        }
    };

    if (!isAdminUser || !loaded) {
        return null;
    }

    return (
        <div className="group-code-approval-comp mb-2">
            <ApprovalComponent
                key={`computer-room-approval-${effectiveProcessId ?? "empty"}`}
                auth
                title="전산실 출입대장 결재라인"
                approvalProcessId={effectiveProcessId}
                onApprovalProcessSet={handleApprovalProcessSet}
            />
            <button type="button" className="group-code-approval-comp__clear pl-2 my-2" onClick={handleClear}>
                결재라인 해제 X
            </button>
        </div>
    );
}

export default ComputerRoomApprovalSettings;
